module.exports = __webpack_public_path__ + "resources/img/sp_partner.c934a36f39a8bc3afb11e6b1b5bac394.png";